import { OptimizelyExpandedValue } from "../../types/optimizely/expanded";
import { SectionPageType } from "../../types/optimizely/sectionpage";

export const sectionPageTypeName = "SectionPage";

export const isSectionPage = (content: OptimizelyExpandedValue): content is SectionPageType => {
  return content.contentType.includes(sectionPageTypeName);
}